import React, { useEffect, useState } from 'react';
import company1 from '..//..//assets/company-1.jpg';
import company2 from '..//..//assets/company-2.jpg';
import abp from '..//..//assets/ABP_img.jpeg';
import { useTheme } from '../../contexts/ThemeContext';

import '../About/About.css';
// import '../About/About_modern.css';

import { FaHandsHelping, FaUsers, FaAward, FaRocket, FaCheckCircle, FaIndustry } from 'react-icons/fa';
import { TbTargetArrow } from 'react-icons/tb';
import { AiOutlineEye } from 'react-icons/ai';

function About() {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);
  
  const achievements = [
    { number: '30+', label: 'Projects Completed', icon: FaCheckCircle },
    { number: '20+', label: 'Happy Clients', icon: FaUsers },
    { number: '2+', label: 'Years Experience', icon: FaAward },
    { number: '100%', label: 'Quality Assured', icon: FaRocket }
  ];
  
  return (
    <div className='modern-about-container'>
      {/* Hero Section */}
      <section className='about-hero-section'>
        <div className='hero-background'></div>
        <div className='hero-overlay'></div>
        <div className='container hero-content'>
          <div className={`hero-text text-center ${isVisible ? 'animate-in' : ''}`}>
            <h1 className='hero-title'>
              <span className='text-gradient'>About</span> Amruth Build Products
            </h1>
            <p className='hero-description'>
              Architects of progress, builders of dreams, and champions of innovation
            </p>
          </div>
        </div>
      </section>
      {/* Company Profile Section */}
      <section className='company-profile-section'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-12' data-aos='fade-right'>
              <div className='profile-content'>
                <h2 className='section-title'>
                  <span className='text-gradient'>Company</span> Profile
                </h2>
                <p className='profile-description'>
                  We take pride in being an innovative construction and manufacturing company, 
                  dedicated to providing top-notch solutions for all your construction needs.
                </p>
                <p className='profile-description'>
                  With years of experience and expertise, we have earned a reputation for 
                  excellence in the industry. Our commitment to quality, customer satisfaction, 
                  and sustainable practices sets us apart as a trusted partner.
                </p>
                <div className='profile-highlights'>
                  <div className='highlight-item'>
                    <FaIndustry className='highlight-icon' />
                    <span>Industry Leading Solutions</span>
                  </div>
                  <div className='highlight-item'>
                    <FaAward className='highlight-icon' />
                    <span>Award Winning Quality</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-6 col-12' data-aos='fade-left'>
              <div className='profile-image'>
                <img src={company1} alt='Company Profile' className='img-fluid rounded-image' />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Achievements Section */}
      <section className='achievements-section'>
        <div className='container'>
          <div className='row'>
            {achievements.map((achievement, index) => {
              const IconComponent = achievement.icon;
              return (
                <div key={index} className='col-lg-3 col-md-6 col-12 mb-4'>
                  <div className='achievement-card' data-aos='fade-up' data-aos-delay={index * 100}>
                    <div className='achievement-icon'>
                      <IconComponent />
                    </div>
                    <div className='achievement-content'>
                      <h3 className='achievement-number'>{achievement.number}</h3>
                      <p className='achievement-label'>{achievement.label}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      {/* Gallery Section */}
      <section className='gallery-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <span className='text-gradient'>Our</span> Journey
            </h2>
            <p className='section-description'>
              A glimpse into our world of construction and manufacturing excellence
            </p>
          </div>
          <div className='gallery-grid'>
            <div className='gallery-item' data-aos='zoom-in' data-aos-delay='100'>
              <img src={company1} alt='Company Image 1' className='gallery-image' />
              <div className='gallery-overlay'>
                <h4>Innovation Hub</h4>
                <p>Where ideas come to life</p>
              </div>
            </div>
            <div className='gallery-item' data-aos='zoom-in' data-aos-delay='200'>
              <img src={company2} alt='Company Image 2' className='gallery-image' />
              <div className='gallery-overlay'>
                <h4>Manufacturing Excellence</h4>
                <p>Precision in every product</p>
              </div>
            </div>
            <div className='gallery-item' data-aos='zoom-in' data-aos-delay='300'>
              <img src={abp} alt='ABP Image' className='gallery-image' />
              <div className='gallery-overlay'>
                <h4>Quality Assurance</h4>
                <p>Meeting the highest standards</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className='values-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <span className='text-gradient'>Framing Our</span> Values
            </h2>
            <p className='section-description'>
              The principles that guide our every decision and action
            </p>
          </div>
          <div className='row g-4'>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='value-card' data-aos='fade-up' data-aos-duration='600'>
                <div className='value-icon'>
                  <AiOutlineEye />
                </div>
                <div className='value-content'>
                  <h3 className='value-title'>Vision</h3>
                  <p className='value-description'>
                    Turning ideas into reality, we reflect our commitment through every structure we create. 
                    Quality, innovation, and sustainability guide us to surpass client expectations.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='value-card' data-aos='fade-up' data-aos-duration='600' data-aos-delay='200'>
                <div className='value-icon'>
                  <TbTargetArrow />
                </div>
                <div className='value-content'>
                  <h3 className='value-title'>Mission</h3>
                  <p className='value-description'>
                    Elevating excellence through inspiring spaces and lasting creations, 
                    driven by technology and unwavering dedication in construction and manufacturing.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='value-card' data-aos='fade-up' data-aos-duration='600' data-aos-delay='400'>
                <div className='value-icon'>
                  <FaHandsHelping />
                </div>
                <div className='value-content'>
                  <h3 className='value-title'>Collaborative Approach</h3>
                  <p className='value-description'>
                    Empowered by collaboration, we partner closely with clients to realize their visions. 
                    Shared goals and commitment drive every step toward excellence.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className='container position-relative my-5'>
        <div className='row d-flex justify-content-between align-items-flex-start'>
          <div
            className='col-lg-5 col-12'
            data-aos='fade-up'
            data-aos-duration='1000'
          >
            <h3 className='about-main-text'>Who We Are</h3>
            <p className='mt-4 px-sm-0 px-3 paragraphs'>
              Beyond a company, a passion, a vision, a commitment. With over 2
              years of expertise, we've refined our craft into an art. Our
              skilled team turns your concepts into enduring realities through
              creative collaboration.
            </p>
          </div>
          <div
            className='col-lg-5 col-12 mt-lg-0 mt-5'
            data-aos='fade-up'
            data-aos-duration='1000'
          >
            <h3 className='about-main-text'>What Sets Us Apart</h3>
            <p className='mt-4 px-sm-0 px-3  paragraphs'>
              Uniqueness drives us.Quality and customer happiness are our
              foundations.Trust in our promise for exceptional results and a
              greener future.
            </p>
          </div>
        </div>
      </div>
      <div className='position-relative container my-5'>
        <div className='row col-12 d-flex justify-content-center align-items-center'>
          <div
            className='col-lg-9 col-12'
            data-aos='fade-up'
            data-aos-duration='1000'
          >
            <h3 className='text-center about-main-text'>What We Do</h3>
            <p className='mt-5 px-sm-0 px-3  paragraphs'>
              Our services span construction and manufacturing, executed with
              precision, ingenuity, and excellence.
            </p>
          </div>
        </div>
        <div
          className='position-relative container mt-5'
          data-aos='fade-up'
          data-aos-duration='1000'
        >
          <div className='position-relative row d-flex justify-content-center align-items-center'>
            <div className='col-lg-5 col-12'>
              <ul>
                <li>
                  <h5 className='content-sub-text'>Planning</h5>
                  We lay the foundation for success through meticulous planning,
                  ensuring that every project is structured to achieve optimal
                  outcomes.
                </li>
              </ul>
            </div>
            <div className='col-lg-5 col-12'>
              <ul>
                <li>
                  <h5 className='content-sub-text'>Designing</h5>
                  Our creative minds fuse artistry and functionality to craft
                  designs that are both visionary and practical, reflecting your
                  unique aspirations.
                </li>
              </ul>
            </div>
          </div>
          <div className='position-relative row justify-content-center align-items-center'>
            <div className='col-lg-5 col-12'>
              <ul>
                <li>
                  <h5 className='content-sub-text'>Estimation and Costing</h5>
                  We provide accurate estimations and cost analyses, helping you
                  make informed decisions and manage your project budget
                  effectively.
                </li>
              </ul>
            </div>
            <div className='col-lg-5 col-12'>
              <ul>
                <li>
                  <h5 className='content-sub-text'>Turnkey Projects</h5>
                  Embrace a seamless construction journey with our turnkey
                  solutions, where we handle every detail from concept to
                  completion.
                </li>
              </ul>
            </div>
          </div>
          <div className='position-relative row justify-content-center align-items-center'>
            <div className='col-lg-5 col-12'>
              <ul>
                <li>
                  <h5 className='content-sub-text'>Construction Materials</h5>
                  We offer a comprehensive range of construction materials,
                  including cement, TMT steel, M sand, jally, dust, and P sand,
                  each meeting the highest standards of quality and reliability.
                </li>
              </ul>
            </div>
            <div className='col-lg-5 col-12'>
              <ul>
                <li>
                  <h5 className='content-sub-text'>Manufacturing Materials</h5>
                  Elevate your projects with our precision-engineered
                  manufacturing materials, including solid blocks, paver blocks,
                  kerb stones, and precast compound walls.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='container choose-us-main-container position-relative my-5'>
        <div className='p-3'>
          <h3 className='text-center about-main-text'>Why Choose Us</h3>
          <div className='row row-data d-flex justify-content-around align-items-center'>
            <div
              className='col-md-3 col-12 choose-us-box'
              data-aos='fade-up'
              data-aos-duration='1000'
            >
              <div className='px-2 py-3'>
                <div className='number'>01</div>
                <div>Innovative Solutions</div>
              </div>
            </div>
            <div
              className='col-md-3 col-12 choose-us-box my-md-0 my-4'
              data-aos='fade-up'
              data-aos-duration='1000'
            >
              <div className='px-2 py-3'>
                <div className='number'>02</div>
                <div>Expertise Beyond Measure</div>
              </div>
            </div>
            <div
              className='col-md-3 col-12 choose-us-box'
              data-aos='fade-up'
              data-aos-duration='1000'
            >
              <div className='px-2 py-3'>
                <div className='number'>03</div>
                <div>Uncompromising Quality</div>
              </div>
            </div>
          </div>
          <div className='row row-data d-flex justify-content-around align-items-center my-md-5 mt-4'>
            <div
              className='col-md-3 col-12  choose-us-box'
              data-aos='fade-up'
              data-aos-duration='1000'
            >
              <div className='px-2 py-3'>
                <div className='number'>04</div>
                <div>Comprehensive Services</div>
              </div>
            </div>
            <div
              className='col-md-3 col-12  choose-us-box my-md-0 my-4'
              data-aos='fade-up'
              data-aos-duration='1000'
            >
              <div className='px-2 py-3'>
                <div className='number'>05</div>
                <div>Customer-Centric Approach</div>
              </div>
            </div>
            <div
              className='col-md-3 col-12  choose-us-box'
              data-aos='fade-up'
              data-aos-duration='1000'
            >
              <div className='px-2 py-3'>
                <div className='number'>06</div>
                <div>Diverse Materials</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
